"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var RadioButton_component_1 = __importDefault(require("@/components/common/RadioButton/RadioButton.component"));
var RadioButtonField = function (props, ref) {
    return (0, jsx_runtime_1.jsx)(RadioButton_component_1.default, __assign({ ref: ref }, props), void 0);
};
exports.default = (0, react_2.forwardRef)(RadioButtonField);
